(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-card-product-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gift-card-section]').forEach((section) => {
    const select = section.querySelector('[data-gift-card-variant-select]');
    const image = section.querySelector('.gift-card-product__image');
    const value = section.querySelector('[data-gift-card-value]');
    const price = section.querySelector('[data-gift-card-price]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      value.textContent = option.dataset.value;
      price.textContent = option.dataset.price;
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.value;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-all-katana-collection-v1"]) return;
  try {
    
  (() => {
    let waitObserver;
    let waitTimer;

    if (!window.__nfAllKatanaPopstateBound) {
      window.__nfAllKatanaPopstateBound = true;
      window.addEventListener('popstate', () => window.location.reload());
    }

    const bindEnhancements = () => {
      const root = document.querySelector('[data-nf-all-katana-root]');
      const drawer = document.querySelector('#shopify-section-facets #t4s-filter-hidden');
      if (!root || !drawer) return false;

      const sectionId = root.dataset.nfSectionId || 'all-katana';
      if (drawer.dataset.nfAllKatanaReady === sectionId) return true;

      drawer.dataset.nfAllKatanaReady = sectionId;
      root.dataset.nfReady = 'true';

      const sortTemplate = root.querySelector('[data-nf-all-katana-sort-template]');
      const resultCount = root.querySelector('[data-result-count]');
      const filterButton = root.querySelector('.t4s-btn-filter');
      let drawerWasOpen = drawer.getAttribute('aria-hidden') === 'false';
      let enhancementQueued = false;

      const updatePreviewOffset = () => {
        const previewBar = document.querySelector('#PBarNextFrameWrapper');
        const previewRect = previewBar?.getBoundingClientRect();
        const offset = previewRect && previewRect.height > 0 && previewRect.bottom >= window.innerHeight - 2
          ? Math.ceil(previewRect.height)
          : 0;
        document.documentElement.style.setProperty('--nf-all-katana-preview-offset', `${offset}px`);
      };

      const syncDrawerState = () => {
        updatePreviewOffset();
        const drawerIsOpen = drawer.getAttribute('aria-hidden') === 'false';
        filterButton?.setAttribute('aria-expanded', drawerIsOpen ? 'true' : 'false');

        if (drawerIsOpen && !drawerWasOpen) {
          window.requestAnimationFrame(() => {
            drawer.querySelector('[data-drawer-close], .t4s-drawer__close, button, a, input, select')?.focus({ preventScroll: true });
          });
        } else if (drawerIsOpen && document.activeElement === filterButton) {
          window.requestAnimationFrame(() => {
            drawer.querySelector('[data-drawer-close], .t4s-drawer__close, button, a, input, select')?.focus({ preventScroll: true });
          });
        } else if (!drawerIsOpen && drawerWasOpen) {
          window.requestAnimationFrame(() => filterButton?.focus({ preventScroll: true }));
        }
        drawerWasOpen = drawerIsOpen;
      };

      const syncSortButtons = (forcedValue) => {
        const selectedToolbarItem = root.querySelector('[data-sortby-item].is--selected');
        const selectedValue = forcedValue || new URL(window.location.href).searchParams.get('sort_by') || selectedToolbarItem?.dataset.value;
        drawer.querySelectorAll('[data-nf-all-sort-value]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.nfAllSortValue === selectedValue ? 'true' : 'false');
        });
      };

      const enhanceDrawer = () => {
        const ajaxCount = root.querySelector('[data-ntajax-container] [data-ajax-result-count]');
        if (ajaxCount && resultCount && ajaxCount.textContent.trim() !== resultCount.textContent.trim()) {
          resultCount.textContent = ajaxCount.textContent.trim();
        }

        const form = drawer.querySelector('#FacetFiltersForm');
        if (form && sortTemplate && !drawer.querySelector('.nf-all-katana-drawer-sort')) {
          form.parentElement.prepend(sortTemplate.content.cloneNode(true));
        }

        let bottom = drawer.querySelector('.t4s-drawer__bottom');
        if (!bottom) {
          bottom = document.createElement('div');
          bottom.className = 't4s-drawer__bottom';
          drawer.querySelector('.t4s-drawer__content')?.append(bottom);
        }

        let showButton = bottom?.querySelector('[data-nf-all-show-results]');
        if (bottom && !showButton) {
          showButton = document.createElement('button');
          showButton.type = 'button';
          showButton.className = 'nf-all-katana-show-results';
          showButton.dataset.nfAllShowResults = '';
          showButton.addEventListener('click', () => drawer.querySelector('[data-drawer-close]')?.click());
          bottom.append(showButton);
        }

        if (showButton) {
          if (showButton.className !== 'nf-all-katana-show-results') {
            showButton.className = 'nf-all-katana-show-results';
          }
          const liveRoot = document.querySelector('[data-nf-all-katana-root]') || root;
          const liveResultCount = liveRoot.querySelector('[data-result-count]');
          const liveAjaxCount = liveRoot.querySelector('[data-ntajax-container] [data-ajax-result-count]');
          const countText = liveResultCount?.textContent?.trim()
            || liveAjaxCount?.textContent?.trim()
            || showButton.dataset.nfLastCount
            || liveRoot.dataset.initialResultsText
            || root.dataset.initialResultsText
            || '';
          const prefix = liveRoot.dataset.showResultsLabel || root.dataset.showResultsLabel || 'Show';
          if (countText) showButton.dataset.nfLastCount = countText;
          const nextText = `${prefix} ${countText}`.trim() || 'Show results';
          if (showButton.textContent !== nextText) showButton.textContent = nextText;
          showButton.setAttribute('aria-label', nextText);
        }

        syncDrawerState();
        syncSortButtons();
      };

      const queueEnhancement = () => {
        if (enhancementQueued) return;
        enhancementQueued = true;
        window.requestAnimationFrame(() => {
          enhancementQueued = false;
          enhanceDrawer();
        });
      };

      drawer.addEventListener('click', (event) => {
        const sortButton = event.target.closest('[data-nf-all-sort-value]');
        if (!sortButton) return;
        const value = sortButton.dataset.nfAllSortValue;
        const toolbarSort = Array.from(root.querySelectorAll('[data-sortby-item]')).find((item) => item.dataset.value === value);
        syncSortButtons(value);
        toolbarSort?.click();
        drawer.querySelector('[data-drawer-close]')?.click();
      });

      root.addEventListener('click', (event) => {
        const layoutButton = event.target.closest('[data-layout-switch] button[data-breakpoint]');
        if (!layoutButton) return;
        const group = layoutButton.closest('.t4s-layout__switch');
        group?.querySelectorAll('button[data-breakpoint]').forEach((button) => {
          button.setAttribute('aria-pressed', button === layoutButton ? 'true' : 'false');
        });
      });

      new MutationObserver(queueEnhancement).observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true
      });
      new MutationObserver(queueEnhancement).observe(root, { childList: true, subtree: true });
      window.addEventListener('resize', updatePreviewOffset, { passive: true });
      updatePreviewOffset();
      enhanceDrawer();
      return true;
    };

    if (bindEnhancements()) return;

    waitObserver = new MutationObserver(() => {
      if (!bindEnhancements()) return;
      waitObserver.disconnect();
      window.clearTimeout(waitTimer);
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
    waitTimer = window.setTimeout(() => waitObserver.disconnect(), 15000);

    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document).on('facets:loaded.nfAllKatana', bindEnhancements);
    }
    document.addEventListener('shopify:section:load', bindEnhancements);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-all-swords-collection-v1"]) return;
  try {
    
  (() => {
    let waitObserver;
    let waitTimer;

    if (!window.__nfAllSwordsPopstateBound) {
      window.__nfAllSwordsPopstateBound = true;
      window.addEventListener('popstate', () => window.location.reload());
    }

    const bindEnhancements = () => {
      const root = document.querySelector('[data-nf-all-swords-root]');
      const drawer = document.querySelector('#shopify-section-facets #t4s-filter-hidden');
      if (!root || !drawer) return false;

      const sectionId = root.dataset.nfSectionId || 'all-swords';
      if (drawer.dataset.nfAllSwordsReady === sectionId) return true;

      drawer.dataset.nfAllSwordsReady = sectionId;
      root.dataset.nfReady = 'true';

      const sortTemplate = root.querySelector('[data-nf-all-swords-sort-template]');
      const resultCount = root.querySelector('[data-result-count]');
      const filterButton = root.querySelector('.t4s-btn-filter');
      let drawerWasOpen = drawer.getAttribute('aria-hidden') === 'false';
      let enhancementQueued = false;

      const updatePreviewOffset = () => {
        const previewBar = document.querySelector('#PBarNextFrameWrapper');
        const previewRect = previewBar?.getBoundingClientRect();
        const offset = previewRect && previewRect.height > 0 && previewRect.bottom >= window.innerHeight - 2
          ? Math.ceil(previewRect.height)
          : 0;
        document.documentElement.style.setProperty('--nf-all-swords-preview-offset', `${offset}px`);
      };

      const syncDrawerState = () => {
        updatePreviewOffset();
        const drawerIsOpen = drawer.getAttribute('aria-hidden') === 'false';
        filterButton?.setAttribute('aria-expanded', drawerIsOpen ? 'true' : 'false');

        if (drawerIsOpen && !drawerWasOpen) {
          window.requestAnimationFrame(() => {
            drawer.querySelector('[data-drawer-close], .t4s-drawer__close, button, a, input, select')?.focus({ preventScroll: true });
          });
        } else if (drawerIsOpen && document.activeElement === filterButton) {
          window.requestAnimationFrame(() => {
            drawer.querySelector('[data-drawer-close], .t4s-drawer__close, button, a, input, select')?.focus({ preventScroll: true });
          });
        } else if (!drawerIsOpen && drawerWasOpen) {
          window.requestAnimationFrame(() => filterButton?.focus({ preventScroll: true }));
        }
        drawerWasOpen = drawerIsOpen;
      };

      const syncSortButtons = (forcedValue) => {
        const selectedToolbarItem = root.querySelector('[data-sortby-item].is--selected');
        const selectedValue = forcedValue || new URL(window.location.href).searchParams.get('sort_by') || selectedToolbarItem?.dataset.value;
        drawer.querySelectorAll('[data-nf-all-sort-value]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.nfAllSortValue === selectedValue ? 'true' : 'false');
        });
      };

      const enhanceDrawer = () => {
        const ajaxCount = root.querySelector('[data-ntajax-container] [data-ajax-result-count]');
        if (ajaxCount && resultCount && ajaxCount.textContent.trim() !== resultCount.textContent.trim()) {
          resultCount.textContent = ajaxCount.textContent.trim();
        }

        const form = drawer.querySelector('#FacetFiltersForm');
        if (form && sortTemplate && !drawer.querySelector('.nf-all-swords-drawer-sort')) {
          form.parentElement.prepend(sortTemplate.content.cloneNode(true));
        }

        let bottom = drawer.querySelector('.t4s-drawer__bottom');
        if (!bottom) {
          bottom = document.createElement('div');
          bottom.className = 't4s-drawer__bottom';
          drawer.querySelector('.t4s-drawer__content')?.append(bottom);
        }

        let showButton = bottom?.querySelector('[data-nf-all-show-results]');
        if (bottom && !showButton) {
          showButton = document.createElement('button');
          showButton.type = 'button';
          showButton.className = 'nf-all-swords-show-results';
          showButton.dataset.nfAllShowResults = '';
          showButton.addEventListener('click', () => drawer.querySelector('[data-drawer-close]')?.click());
          bottom.append(showButton);
        }

        if (showButton) {
          if (showButton.className !== 'nf-all-swords-show-results') {
            showButton.className = 'nf-all-swords-show-results';
          }
          const liveRoot = document.querySelector('[data-nf-all-swords-root]') || root;
          const liveResultCount = liveRoot.querySelector('[data-result-count]');
          const liveAjaxCount = liveRoot.querySelector('[data-ntajax-container] [data-ajax-result-count]');
          const countText = liveResultCount?.textContent?.trim()
            || liveAjaxCount?.textContent?.trim()
            || showButton.dataset.nfLastCount
            || liveRoot.dataset.initialResultsText
            || root.dataset.initialResultsText
            || '';
          const prefix = liveRoot.dataset.showResultsLabel || root.dataset.showResultsLabel || 'Show';
          if (countText) showButton.dataset.nfLastCount = countText;
          const nextText = `${prefix} ${countText}`.trim() || 'Show results';
          if (showButton.textContent !== nextText) showButton.textContent = nextText;
          showButton.setAttribute('aria-label', nextText);
        }

        syncDrawerState();
        syncSortButtons();
      };

      const queueEnhancement = () => {
        if (enhancementQueued) return;
        enhancementQueued = true;
        window.requestAnimationFrame(() => {
          enhancementQueued = false;
          enhanceDrawer();
        });
      };

      drawer.addEventListener('click', (event) => {
        const sortButton = event.target.closest('[data-nf-all-sort-value]');
        if (!sortButton) return;
        const value = sortButton.dataset.nfAllSortValue;
        const toolbarSort = Array.from(root.querySelectorAll('[data-sortby-item]')).find((item) => item.dataset.value === value);
        syncSortButtons(value);
        toolbarSort?.click();
        drawer.querySelector('[data-drawer-close]')?.click();
      });

      root.addEventListener('click', (event) => {
        const layoutButton = event.target.closest('[data-layout-switch] button[data-breakpoint]');
        if (!layoutButton) return;
        const group = layoutButton.closest('.t4s-layout__switch');
        group?.querySelectorAll('button[data-breakpoint]').forEach((button) => {
          button.setAttribute('aria-pressed', button === layoutButton ? 'true' : 'false');
        });
      });

      new MutationObserver(queueEnhancement).observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true
      });
      new MutationObserver(queueEnhancement).observe(root, { childList: true, subtree: true });
      window.addEventListener('resize', updatePreviewOffset, { passive: true });
      updatePreviewOffset();
      enhanceDrawer();
      return true;
    };

    if (bindEnhancements()) return;

    waitObserver = new MutationObserver(() => {
      if (!bindEnhancements()) return;
      waitObserver.disconnect();
      window.clearTimeout(waitTimer);
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
    waitTimer = window.setTimeout(() => waitObserver.disconnect(), 15000);

    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document).on('facets:loaded.nfAllSwords', bindEnhancements);
    }
    document.addEventListener('shopify:section:load', bindEnhancements);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-standard-product-conversion"] && !Shopify.designMode) return;
  try {
    
  function nfLoadStandardProductVideo(video) {
    if (!video || video.dataset.nfVideoReady === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function(source) {
      source.setAttribute('src', source.dataset.src);
      source.removeAttribute('data-src');
    });
    video.dataset.nfVideoReady = 'true';
    video.load();
    if (video.autoplay) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() {});
    }
  }

  function nfInitStandardProductVideos() {
    var videos = document.querySelectorAll('.nf-standard-product video[data-nf-lazy-video]');
    if (!videos.length) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          nfLoadStandardProductVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '160px 0px' });
      videos.forEach(function(video) { observer.observe(video); });
    } else {
      videos.forEach(nfLoadStandardProductVideo);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nfInitStandardProductVideos);
  } else {
    nfInitStandardProductVideos();
  }

  } catch(e) { console.error(e); }
})();
})();
